// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__vEQk3","tab":"Tabs_tab__JPd5r","isActive":"Tabs_isActive__RRr2d"};